import Link from "next/link";
import useTranslation from "next-translate/useTranslation";
import { learningDestinations } from "./learningNavigation";

export default function LearningPagesNavigation({
  page,
}: {
  page: "path" | "lessons";
}) {
  const { t } = useTranslation("common");
  return (
    <nav
      aria-label={t("Learn")}
      className="mb-6 inline-flex max-w-full rounded-lg bg-athens-gray-200 p-1"
    >
      {learningDestinations.map(({ href, menuLabel }, index) => {
        const active = page === "path" ? index === 0 : index === 1;
        return (
          <Link
            key={href}
            href={href}
            aria-current={active ? "page" : undefined}
            className={`flex min-h-[40px] min-w-0 flex-1 items-center justify-center rounded-md px-3 py-2 text-center text-sm font-semibold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-altblue-500 md:flex-none ${active ? "bg-white text-slate-900 shadow-sm" : "text-slate-600 hover:text-slate-900"}`}
          >
            {t(menuLabel)}
          </Link>
        );
      })}
    </nav>
  );
}
